import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import mainReducer from "./mainReducer";

export const mainStore = configureStore({
  reducer: mainReducer,
  middleware: [thunk],
});
